import { endpoints } from '@/api/endpoints';
import {
  acceptOfferResponseSchema,
  loanFeaturesStepsResponseSchema,
  signOfferResponseSchema,
  withdrawalStatusResponseSchema,
} from '@/api/SE/loan/schemas';
import { apiRequest } from '@/api/utils/api';

export const signOffer = (applicationId: string) =>
  apiRequest({
    url: endpoints.SE.loan.applications.applicationId(applicationId).signOffer,
    method: 'POST',
    schema: signOfferResponseSchema,
  });

export const signPartnerOffer = (
  applicationId: string,
  productTierId: string,
  numberOfInstallments: number,
) =>
  apiRequest({
    url: endpoints.SE.loan.applications.applicationId(applicationId).signOffer,
    method: 'POST',
    data: { productTierId, numberOfInstallments },
    schema: signOfferResponseSchema,
  });

export const acceptOffer = (applicationId: string) =>
  apiRequest({
    url: endpoints.SE.loan.applications.applicationId(applicationId).acceptOffer,
    method: 'POST',
    schema: acceptOfferResponseSchema,
  });

export const declineOffer = (applicationId: string) =>
  apiRequest<void>({
    url: endpoints.SE.loan.applications.applicationId(applicationId).declineOffer,
    method: 'POST',
  });

export const getWithdrawalStatus = () =>
  apiRequest({
    url: endpoints.SE.loan.withdrawal.status,
    method: 'GET',
    schema: withdrawalStatusResponseSchema,
  });

export const getFeaturesSteps = () =>
  apiRequest({
    url: endpoints.SE.loan.featuresSteps,
    method: 'GET',
    schema: loanFeaturesStepsResponseSchema,
  });
